import { UploadOutlined } from "@ant-design/icons";
import { Button, Card, message, Upload } from "antd";
import { useState } from "react";
import styled from "styled-components";

const { Dragger } = Upload;

const StyledDragger = styled(Dragger)`
  margin: 12px 0;
`;

const StyledCard = styled(Card)`
  max-width: 450px;
  text-align: center;

  .ant-upload-list {
    text-align: center;
  }
`;

const StyledUploadButton = styled(Button)`
  margin-top: 16px;
`;

export default function MultirowFileUpload({ onSubmit, isLoading, providerLabel }) {
  const [fileList, setFileList] = useState([]);

  const draggerProps = {
    multiple: false,
    showUploadList: {
      showDownloadIcon: false,
    },
    onRemove: () => {
      setFileList([]);
    },
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },
    fileList,
    accept: ".txt",
  };

  const handleUpload = () => {
    if (fileList.length === 0) {
      message.error("Please select a file to upload");
      return;
    }
    onSubmit(fileList[0]);
  };

  return (
    <StyledCard>
      <StyledDragger {...draggerProps}>
        <p className="ant-upload-drag-icon">
          <UploadOutlined />
        </p>
        <p className="ant-upload-text">Click or drag file to upload</p>
        <p className="ant-upload-hint">
          Supports TXT files. Field mapping will use {providerLabel} configuration.
        </p>
      </StyledDragger>
      <StyledUploadButton
        type="primary"
        onClick={handleUpload}
        disabled={fileList.length === 0}
        loading={isLoading}
      >
        Upload and Import
      </StyledUploadButton>
    </StyledCard>
  );
}
